/** @format */

import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { scrollToId } from "../../../../../Helpers";

const PageLocator = ({ containerRef, pdfPagesRef }) => {
  const { pdfPages } = useSelector((state) => state.pdfDetails || []);
  const [pageNumber, setPageNumber] = useState(1);
  const [pages, setPages] = useState([]); // Store observed pages
  const observerRef = useRef(null);

  useEffect(() => {
    if (!pdfPagesRef.current || pdfPagesRef.current.length === 0) return;

    setPages([...pdfPagesRef.current]); // Update state when ref changes

    const options = {
      root: null,
      rootMargin: "0px",
      threshold: [0, 0.5, 1],
    };

    const observer = new IntersectionObserver(handleIntersect, options);
    observerRef.current = observer;

    pdfPagesRef.current.forEach((page) => {
      if (page instanceof Element) {
        observer.observe(page);
      }
    });

    return () => {
      observer.disconnect();
    };
  }, [pdfPages]); // Now the effect runs when pdfPages change

  const handleIntersect = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const pageIndex = parseInt(entry.target.getAttribute("data-page-index"));
        setPageNumber(pageIndex + 1);
      }
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (pageNumber > 0 && pageNumber <= pdfPages?.length) {
      scrollToId(`page-${pageNumber}`, pdfPages, containerRef);
    } else {
      setPageNumber(pdfPages?.length);
    }
  };

  const handlePageNumber = (e) => {
    const value = e.target.value;
    const parsed = parseInt(value, 10);
  
    // Only allow integers >= 1
    if (!isNaN(parsed) && parsed >= 1) {
      setPageNumber(parsed);
    } else if (value === "") {
      setPageNumber(""); // Allow temporary empty state
    }
  };

  return (
    <Container>
      <form onSubmit={handleSubmit}>
        <div className='innerDiv'>
          <input
            type='number'
            value={pageNumber}
            onChange={handlePageNumber}
            style={inputStyle}
            min={1}
            max={pdfPages?.length || 1}
          />
          <div>/</div>
          <p style={{ fontSize: "14px", marginLeft: 2 }}>{pdfPages?.length}</p>
        </div>
      </form>
    </Container>
  );
};

export default PageLocator;

// Styles
const inputStyle = {
  width: "35%",
  border: "none",
};

const Container = styled.div`
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  width: fit-content;
  input:focus {
    outline: none;
  }
  .innerDiv {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #ccc;
    height: 35px;
    width: 70px;
  }
`;
